import { createRoutine } from 'redux-saga-routines';

import { GET_RENTALS, GET_RENTALS_AGGREGATIONS, SET_START_AGGREGATIONS, CLEAN_RENTALS_AGGREGATIONS } from './constants';

export const getRentals = createRoutine(GET_RENTALS);
export const getRentalsAggregations = createRoutine(GET_RENTALS_AGGREGATIONS);
export const cleanRentalsAggregations = createRoutine(CLEAN_RENTALS_AGGREGATIONS);
export const setStartAggregationAction = createRoutine(SET_START_AGGREGATIONS);
